<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ONEWAY, OPENJAW, ROUNDTRIP } from '@/constants';
import RadioButton from 'primevue/radiobutton';

interface Props {
  referenceType?: string;
  index?: number;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  changeTypeTrip: [];
  'update:tourData': [value: any];
  'update:referenceType': [value: any];
}>();

const { t } = useI18n({ useScope: 'global' });

const referenceTypeData = computed({
  get() {
    return props.referenceType;
  },
  set(value) {
    emits('update:referenceType', value);
  }
});

const tripType = ref([
  {
    label: t('advance_quote.form.round_trip'),
    type: ROUNDTRIP
  },
  {
    label: t('advance_quote.form.open_jaw'),
    type: OPENJAW
  },
  {
    label: t('advance_quote.form.one_way'),
    type: ONEWAY
  }
]);

const changeTypeTrip = () => {
  emits('changeTypeTrip');
};
</script>

<template>
  <div>
    <div class="type-view flex justify-content-between">
      <div v-for="type in tripType" :key="type.label" class="mr-3">
        <RadioButton v-model="referenceTypeData" :inputId="`${type.label} + ${index}`" :value="type.type" class="mr-1" @change="changeTypeTrip()" />
        <label :for="`${type.label} + ${index}`">{{ type.label }}</label>
      </div>
    </div>
  </div>
</template>
